import { combineEpics } from 'redux-observable';
import fetchDailyMatches from './fetchDailyMatches';
import resetFilters from './resetFilters';
import orderCompetitions from './orderCompetitions';
import createMatch from './createMatch';
import editMatch from './editMatch';
import editCompetition from './editCompetition';
import serverUpdateAll from './serverUpdateAll';

export const matchesEpic = combineEpics(
  fetchDailyMatches,
  resetFilters,
  orderCompetitions,
  createMatch,
  editMatch,
  editCompetition,
  serverUpdateAll,
);
